<template>
  <div class="task_detial_box">
    <div class="detial_box">
      <div class="first_box box">
        <div class="title">视频/图文矩阵剪辑需求</div>
        <div class="tip">发布企业：<span style="color: #666666 ;">挺有创意文化传媒招聘</span></div>
        <div class="tip">发布时间：<span style="color: #666666 ;">2025-08-15 15:00</span></div>
        <div class="tip">期望完成日期：<span style="color: #666666 ;">2025-09-15</span></div>
        <div class="footer_box">
          <div class="left">
            <span class="tag c_blur">企业需求</span>
            <span class="tag c_green">招募</span>
            <span class="line"></span>
            <span class="tag c_red">二级分类名称</span>
            <span class="tag c_blur">报名中</span>
          </div>
          <div class="right">
            <span class="time">报名截止时间：2025-08-30 20:00</span>
            <el-button @click="openSignup">报名</el-button>
          </div>
        </div>
      </div>
      <div class="second_box box">
        <div class="title">任务当前阶段</div>
        <!-- <el-steps :active="1">
          <el-step v-for="item in setpData" :title="item">
            <template #icon>
              <div class="step-dot"></div>
            </template>
          </el-step>
        </el-steps> -->
        <div class="setp_box">
          <div class="item" :class="currentSetp>=item.id?'active_item':''" v-for="item in setpData" :style="{width:item.name!='评价'?'15.6%':'8px'}">
            <div class="circle"></div>
            <div class="line" v-if="item.id!=7"></div>
            <div class="label" :class="item.id==7?'last_label':''">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div class="third_box box">
        <div class="header">
          <div class="tab_item" :class="tabValue==item.id?'active_tab_item':''" v-for="item in tabData" :key="item.id" @click="activeTab(item.id)">
            {{ item.name }}
          </div>
        </div>
        <div class="content">

          <OverviewRequirements v-if="tabValue==1" />
          <AllCandidates v-if="tabValue==2" />

        </div>
      </div>

    </div>
    <el-dialog title="报名信息" :visible.sync="singUpDialog" width="720px" :before-close="handleClose">
      <div class="dialog_content">
        <div class="form_item">
          <div class="label">报价：金币</div>
          <div class="value"><el-input-number style="width: 526px; height: 32px;" class="input_number" :min="1" :max="999999999" :precision="0" v-model="singUpFrom.price" :controls="false" placeholder="请输入"></el-input-number></div>
        </div>
        <div class="form_item">
          <div class="label">报名说明：</div>
          <div class="value">
            <el-input type="textarea" resize="none" style="width: 526px; height: 120px;" maxlength="500" show-word-limit placeholder="请输入内容" v-model="singUpFrom.desc">
            </el-input>
          </div>
        </div>
        <div class="form_item">
          <div class="label">添加链接：</div>
          <div class="value">
            <div v-for="(item,index) in singUpFrom.http_url" class="url_item">
              <el-input style="margin-right: 20px;width: 200px;" v-model="item.name" placeholder="请输入链接名称" minlength="1" maxlength="20"></el-input>
              <el-input style="margin-right: 20px;width: 200px;" v-model="item.url" placeholder="请输入链接地址"></el-input>
              <i class="el-icon-delete" style="color: #FF0000;font-size: 22px;" @click="deleteUrl(index)"></i>
            </div>
            <el-link @click="addUrl" style="color: #594FED;" :underline="false">添加链接</el-link>
          </div>
        </div>
        <div class="form_item">
          <div class="label">上传附件：</div>
          <div class="value">
            <div class="file_box" v-for="(item,index) in singUpFrom.file_list">
              <div class="name_box"><span class="name">{{ item.name }}</span><i v-if="item.process==100" class="el-icon-download"></i></div>
              <el-popconfirm @confirm="deleteFile(index)" class="popconfirm" hide-icon title="确定删除该资源？">
                <i class="el-icon-circle-close" slot="reference"></i>
              </el-popconfirm>

              <el-progress color="#594FED" :percentage="item.process" v-show="item.process!=100"></el-progress>
            </div>
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-preview="handlePreview" :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="3" :on-exceed="handleExceed"
              :file-list="fileList" :show-file-list="false" :before-upload="beforeUpload" :on-progress="onProgress">
              <el-link style="color: #594FED;" :underline="false">上传附件</el-link>
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="singUpDialog = false">取 消</el-button>
        <el-button type="primary" @click="singUpDialog = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import AllCandidates from "../../../../components/recruitmentCenter/AllCandidates.vue";
import OverviewRequirements from "../../../../components/recruitmentCenter/OverviewRequirements.vue";
export default {
  name: "",
  components: {
    AllCandidates,
    OverviewRequirements,
  },
  data() {
    return {
      currentSetp: 1,
      setpData: [
        { id: 1, name: "报名" },
        { id: 2, name: "需求方甄选" },
        { id: 3, name: "签订合同" },
        { id: 4, name: "接单方工作" },
        { id: 5, name: "验收交付成果" },
        { id: 6, name: "酬劳结算" },
        { id: 7, name: "评价" },
      ],
      tabData: [
        {
          id: 1,
          name: "需求概览",
        },
        {
          id: 2,
          name: "全部人选",
        },
      ],
      tabValue: 1,
      singUpFrom: {
        price: null,
        desc: "",
        http_url: [],
        file_list: [],
      },
      rule: {},
      singUpDialog: false,
      fileList: [],
    };
  },
  mounted() {},
  methods: {
    activeTab(id) {
      this.tabValue = id;
      this.currentSetp = id == 2 ? 3 : 1;
    },
    openSignup() {
      this.singUpDialog = true;
    },
    confirmSign() {},
    handleClose() {
      this.singUpDialog = false;
    },
    addUrl() {
      this.singUpFrom.http_url.push({ name: "", url: "" });
    },
    deleteUrl(index) {
      this.singUpFrom.http_url.splice(index, 1);
    },
    handlePreview() {},
    handleRemove() {},
    beforeRemove() {},
    handleExceed() {},
    beforeUpload(file) {
      console.log(file, "pppppp");
      let size = parseFloat(file.size / (1024 * 1024).toFixed(2));
      let obj = {
        uid: file.uid,
        name: file.name,
        size: size,
        url: "",
        process: 0,
      };
      this.singUpFrom.file_list.push(obj);
    },
    onProgress(event, file, fileList) {
      this.singUpFrom.file_list.forEach((item) => {
        if (item.uid == file.uid) {
          item.process = parseFloat(event.percent.toFixed(1));
        }
      });
      if (event.percent == 100) {
        this.$message.success("上传成功");
      }
    },
    deleteFile(index) {
      this.singUpFrom.file_list.splice(index, 1);
    },
  },
};
</script>
<style lang='scss' scoped>
.task_detial_box {
  width: 100%;
  .detial_box {
    width: 1200px;
    margin: 0 auto;
    .box {
      width: 100%;
      box-sizing: border-box;

      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 20px;
    }

    .first_box {
      height: 234px;
      padding: 24px;
      background: #ffffff;
      .title {
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        margin-bottom: 20px;
      }
      .tip {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-bottom: 10px;
      }
      .footer_box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .left {
          display: flex;
          align-items: center;
          .tag {
            padding: 5px 11px;
            margin-right: 10px;
            font-weight: 400;
            font-size: 12px;
            border-radius: 4px 4px 4px 4px;
          }
          .c_blur {
            color: #4b9fff;
            background: #ecf5ff;
            border: 1px solid #b3d8ff;
          }
          .c_green {
            color: #6bc45c;
            background: #f6ffed;
            border: 1px solid #01a04b;
          }
          .c_red {
            color: #f56c6c;
            background: #fef1f1;
            border: 1px solid #fde2e2;
          }
        }
        .right {
          display: flex;
          align-items: center;
          .time {
            font-weight: 400;
            font-size: 14px;
            color: #ffa72b;
            margin-right: 16px;
          }
          .el-button {
            width: 120px;
            height: 40px;
            background: linear-gradient(270deg, #594fed 0%, #291ce7 100%);
            border-radius: 20px 20px 20px 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }
    .second_box {
      height: 188px;
      padding: 24px;
      background: #ffffff;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        margin-bottom: 40px;
      }
      .setp_box {
        display: flex;
        align-items: center;
        justify-content: center;

        .item {
          width: 13.6%;
          display: flex;
          align-items: center;
          position: relative;
          .circle {
            width: 8px;
            height: 8px;
            background: #bfbfbf;
            border-radius: 50%;
            flex-shrink: 0;
          }
          .line {
            flex: 1;
            width: 0;
            height: 2px;
            background: #e9e9e9;
          }
          .label {
            color: #666666;
            position: absolute;
            top: 20px;
            transform: translateX(-50%);
          }
          .last_label {
            width: 56px;
            transform: translateX(-4px);
          }
        }
        .circle {
          width: 8px;
          height: 8px;
          background: #bfbfbf;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .active_item {
          .circle {
            background: #384beb;
          }
          .label {
            color: #262626;
          }
          .line {
            background: #384beb;
          }
        }
      }
    }
    .third_box {
      .header {
        display: flex;
        align-items: center;
        padding: 0px 34px;
        border-bottom: 1px solid #ececec;
        background: #ffffff;
        .tab_item {
          padding: 14px 0;
          margin-right: 36px;
          cursor: pointer;
        }
        .active_tab_item {
          color: #4658ed;
          border-bottom: 2px solid #4658ed;
        }
      }
      .content {
      }
    }
  }
}
.step-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #c0c4cc; /* 未激活状态颜色 */
  margin: 0 auto;
}
::v-deep .el-step__icon.is-text {
  border: none;
}
::v-deep .el-step__icon {
  width: 12px;
}
::v-deep .el-dialog__header {
  border-bottom: 1px solid #dde6f3;
  padding: 17px 30px;
}
.dialog_content {
  padding: 0px 28px;
  box-sizing: border-box;
  .form_item {
    width: 100%;
    display: flex;
    margin-bottom: 24px;
    .label {
      width: 70px;
      margin-right: 10px;
    }
    .value {
      width: calc(100% - 80px);
      .url_item {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 16px;

        .el-icon-delete {
          color: #ff0000;
          font-size: 22px;
        }
      }
      .file_box {
        padding: 10px 12px;
        background: #f4f4f4;
        border-radius: 4px 4px 4px 4px;
        margin-bottom: 25px;
        position: relative;
        .name_box {
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
          .name {
            width: 300px;
            display: inline-block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .el-icon-download {
            margin-left: 10px;
            font-size: 18px;
          }
        }
        .el-icon-circle-close {
          position: absolute;
          top: -9px;
          right: -6px;
          color: #ff0000;
          font-size: 18px;
          cursor: pointer;
        }
      }
    }
  }
}
.dialog-footer {
  display: flex;
  align-items: center;
  justify-content: end;
  .el-button {
    width: 78px;
    height: 32px;
    background: #ffffff;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    &:nth-of-type(2) {
      color: #fff;
      background: #594fed;
    }
  }
}
::v-deep .el-textarea__inner {
  height: 120px;
  resize: none;
}
::v-deep .el-input__inner {
  text-align: left;
}
::v-deep .el-popconfirm__action {
  .el-button {
    color: #384beb !important;
  }
}
</style>
<style>
.el-popconfirm__action {
  .el-button {
    width: 45px;
    height: 24px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    font-weight: 400;
    font-size: 12px;
    color: #646669;
    padding: 0;
  }
  .el-button:nth-child(2) {
    background: #594fed;
    color: #fff;
  }
}
</style>